import React from "react"
import { Link, StaticQuery, graphql } from "gatsby"
import styled from 'styled-components'

interface IQueryData {
  allWordpressPost: {
    edges: {
      node: {
        id: string
        title: string
        path: string
      }
    }[]
  }
}

const query = graphql`
  query {
    allWordpressPost(limit: 5, sort: {fields: date, order: DESC}) {
      edges {
        node {
          id
          title
          path
        }
      }
    }
  }
`

const LatestPosts = () => (
  <StaticQuery
    query={query}
    render={(data: IQueryData) => {

      const { edges } = data.allWordpressPost

      if (!edges.length) return null

      const posts = edges.map(({ node }) => <Link key={node.id} to={node.path}>{node.title}</Link>)

      return (
        <Links className="latest-posts">{posts}</Links>
      )
    }}
  />
)

const Links = styled.div`
  a {
    color: #333;
    display: block;
    font-weight: 500;
    padding: 0.3em 1em;
  }
`

export default LatestPosts
